<template>
    <center>
        <div class="card card-body agatrs-card-style">
            <Header pageTitle="Create a Report" class="card-container"></Header>
            <div class="row">
                <div class="col-md-2 offset-md-2 align-left">
                    <label>Service / Parent Organization:</label>
                </div>

                <div class="col-md-5">
                    <treeselect :disabled="report.organizationIds && report.organizationIds.length > 0"
                        v-model="report.services" name="ServicesDropDown" :multiple="true"
                        id="Name" label="Name" :value-consists-of="'LEAF_PRIORITY'"
                        :openOnClick="true" :clearable="true" :searchable="true"
                        :options="[{ id: 0, label: 'All', children: serviceList }]" placeholder="Select" />
                </div>
            </div>
            <spam v-if="report.organizationIds && report.organizationIds.length > 0">If organization is selected, service
                will be disabled. </spam>

            <div class="row">
                <div class="col-md-2 offset-md-2 align-left">
                    <label>Organization and Component:</label>
                </div>
                <!-- .vue-treeselect__control { -->
                <div class="col-md-5">
                    <treeselect placeholder="Select" :disabled="report.services && report.services.length > 0"
                        v-model="report.organizationIds" class="select-primary" name="organization" id="Name"
                        :value-consists-of="'ALL'" :multiple="true" :openOnClick="true" :limit="10" :clearable="true"
                        :searchable="true" search-nested :options="jointStaffOrganizations" />
                </div>
            </div>
            <spam v-if="report.services && report.services.length > 0">If service is selected, organization will be
                disabled.</spam>

            <div class="row">
                <div class="col-md-2 offset-md-2 align-left">
                    <label>Partner Nation:</label>
                </div>
                <div class="col-md-5">
                    <treeselect v-model="report.countryIds" name="PartnerNationDropdown" id="Name" label="Name"
                        :value-consists-of="'LEAF_PRIORITY'" :multiple="true" :openOnClick="true" :limit="10"
                        :clearable="true" :searchable="true"
                        :options="[{ id: 0, label: 'All', children: partnerNationOptions }]" placeholder="Select" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 offset-md-2 align-left">
                    <label>Operation / Theater:</label>
                </div>
                <div class="col-md-5">
                    <treeselect v-model="report.theaterIds" name="OperationTheaterDropdown" value="Name" label="Name"
                        :value-consists-of="'LEAF_PRIORITY'" :multiple="true" :openOnClick="true" :limit="10"
                        :clearable="true" :searchable="true"
                        :options="[{ id: 0, label: 'All', children: operationTheaterOptions }]" placeholder="Select" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 offset-md-2 align-left">
                    <label>Order Status:</label>
                </div>
                <div class="col-md-5">
                    <treeselect v-model="report.orderStatusIds" name="StatusDropdown" value="Name"
                        :value-consists-of="'LEAF_PRIORITY'" :multiple="true" :openOnClick="true" :limit="10"
                        :clearable="true" :searchable="true"
                        :options="[{ id: 0, label: 'All', children: statusOptions }]" placeholder="Select" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 offset-md-2 align-left">
                    <label>Order State:</label>
                </div>
                <div class="col-md-5">
                    <treeselect v-model="report.orderStateIds" name="StateDropdown" value="Name"
                        :value-consists-of="'LEAF_PRIORITY'" :multiple="true" :openOnClick="true" :limit="10"
                        :clearable="true" :searchable="true"
                        :options="[{ id: 0, label: 'All', children: stateOptions }]" placeholder="Select" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 offset-md-2 align-left">
                    <label>Method of Payment:</label>
                </div>
                <div class="col-md-5">
                    <treeselect v-model="report.paymentMethodIds" name="MethodOfPaymentDropdown" value="Name"
                        :value-consists-of="'LEAF_PRIORITY'" :multiple="true" :openOnClick="true" :limit="10"
                        :clearable="true" :searchable="true"
                        :options="[{ id: 0, label: 'All', children: methodOfPaymentOptions }]" placeholder="Select" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 offset-md-2 align-left">
                    <label>Fiscal Year:</label>
                </div>
                <div class="col-md-5">
                    <treeselect v-model="report.years" name="FiscalYear" value="Name"
                        :value-consists-of="'LEAF_PRIORITY'" :multiple="true" :openOnClick="true" :limit="10"
                        :clearable="true" :searchable="true" :options="[{ id: 0, label: 'All', children: fiscalYears }]"
                        placeholder="Select" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 offset-md-2 align-left">
                    <label>Order Date (From):</label>
                </div>
                <div class="col-md-5">
                    <base-input>
                        <el-date-picker v-model="report.from" type="date" placeholder="From Date"></el-date-picker>
                    </base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 offset-md-2 align-left">
                    <label>Order Date (To):</label>
                </div>
                <div class="col-md-5">
                    <base-input>
                        <el-date-picker v-model="report.to" type="date" placeholder="To Date"></el-date-picker>
                    </base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 offset-md-2 align-left">
                    <label>Report Type:</label>
                </div>

                <div class="col-md-5">
            
                    <el-radio label="LINEITEM" v-model="report.type" @change="columnSwitch()">Line Item
                        Report</el-radio>

        
                    <el-radio label="ORDER" v-model="report.type" @change="columnSwitch()">Order Report</el-radio>
                </div>
                    </div>
            <div class="row more-top-padding">
                <div class="col-md-2 offset-md-2 align-left">
                    <label>{{ typeText }} Columns</label>
                </div>
                <div class="col-md-5">
                    <treeselect v-model="report.columns" name="ColumnsDropdown" :value-consists-of="'LEAF_PRIORITY'"
                        :multiple="true" :openOnClick="true" :limit="10" :clearable="true" :searchable="true"
                        :options="[{ id: 0, label: 'All', children: columns }]" placeholder="Select" />
                </div>
            </div>
            <br>
            <div class="row row justify-content-center">
                <div class="d-flex justify-content-md-center">
                    <base-button @click="clear()" type="danger">
                        <i class="tim-icons icon-alert-circle-exc"></i> Clear
                    </base-button>
                </div>

                <div class="d-flex justify-content-md-center justify-content-end">
                    <base-button @click="generateReportPrompt()" type="primary">
                        <i class="tim-icons icon-atom"></i> Generate {{ typeText }}
                    </base-button>
                </div>
            </div>
            <hr>
            <h3>Reports</h3>
            <order-report-grid></order-report-grid>

        </div>
    </center>
</template>

<script>
import Header from "@/components/App/Header";
import { Radio } from "element-ui";
import Treeselect from "@riophae/vue-treeselect";
import OrderReportGrid from "@/components/App/report/order/OrderReportGrid.vue";
import Utility from "@/mixins/utility/utility";
import LoadingAlertMixin from "@/mixins/docLoadingAlert";
import Util from "@/util/util";
import swal from "sweetalert2";
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "CreateReport",
    mixins: [Utility, LoadingAlertMixin],
    components: {
        Header,
        Treeselect,
        [Radio.name]: Radio,
        OrderReportGrid,
    },
    data() {
        return {
            error: false,
        }
    },
    async mounted() {
        this.$loaderApp.addRequest();
        await this.getJointStaffOrganizations();
        await this.getAllCountries();
        await this.getAllOperationTheatres();
        await this.getStatuses();
        await this.getAllServices();
        await this.getStates();
        await this.getPaymentMethods();
        await this.getFiscalYears();
        await this.getColumns();
        this.$loaderApp.completeRequest();
    },
    computed: {
        ...mapGetters({
            jointStaffOrganizations: "orderReport/jointStaffOrganizations",
            partnerNationOptions: "orderReport/countries",
            operationTheaterOptions: "orderReport/theaters",
            statusOptions: "orderReport/statuses",
            stateOptions: "orderReport/states",
            methodOfPaymentOptions: "orderReport/paymentMethods",
            fiscalYears: "fiscalYears/fiscalYearsAsStrings",
            orderColumns: "orderReport/orderColumns",
            lineItemColumns: "orderReport/lineItemColumns",
            report: "orderReport/report",
            allServices: "services/services",
            reportType: "orderReport/reportType",

        }),
        columns: function () {
            return this.report.type === "LINEITEM" ? this.lineItemColumns : this.orderColumns;
        },
        typeText: function () {
            return this.report.type === "LINEITEM" ? "Line Item" : "Order";
        },
        serviceList: function () {
            if (this.allServices) {
                return this.allServices.reduce((names, node) => {
                    names.push({ id: node.displayName, label: node.displayName, name: node.displayName }); // Use your custom field here
                    return names;
                }, []);
            }
        }
    },

    methods: {
        ...mapActions({
            getJointStaffOrganizations: "orderReport/getJointStaffOrganizations",
            getAllCountries: "orderReport/getCountries",
            getAllOperationTheatres: "orderReport/getTheaters",
            getStatuses: "orderReport/getStatuses",
            getPaymentMethods: "orderReport/getPaymentMethods",
            getFiscalYears: "fiscalYears/getFiscalYearsAsStrings",
            getColumns: "orderReport/getColumns",
            getReport: "orderReport/getReport",
            getStates: "orderReport/getStates",
            getAllServices: "services/getServices",
            clear: "orderReport/clearReport",
        }),
        columnSwitch() {
            this.report.columns = null
        },
        generateReportPrompt() {

            if (!this.report.columns || this.report.columns.length == 0) {
                this.excelLoadTime = 0;
                this.$toast.error(`${this.report.type} Columns is required`);
                return;
            }

            Util.swalConfirmation("warning",
                `You will not be able to generate another report until the current report has been completed.`,
                `Do you wish to generate the report?`, `Yes`, true)
                .then((result) => {
                    if (!result.value) {
                        return;
                    } else {
                        this.generateReport();
                    }
                })
        },
        async generateReport() {
            let ctx = this;
            ctx.error = false



            ctx.excelLoadTime += 1;

            var data = {
                Type: ctx.report.type,
                Organizations: ctx.report.organizationIds,
                Services: ctx.report.services,
                Countries: ctx.report.countryIds,
                Theaters: ctx.report.theaterIds,
                OrderStatuses: ctx.report.orderStatusIds,
                OrderState: ctx.report.orderStateIds,
                PaymentMethods: ctx.report.paymentMethodIds,
                Years: ctx.report.years,
                Columns: ctx.report.columns,
                From: ctx.report.from,
                To: ctx.report.to
            }

            axios({
                url: '/api/orderreports/generate',
                method: "POST",
                data: data,
                responseType: "blob", // important
                config: {
                    showToast: true,
                    message: "Report generated successfully!",
                }
            }).then((response) => {
                Util.fileDownload(response.data, "item-report.xlsx");
                ctx.excelLoadTime = 0
            }).catch((error) => {
                this.error = true
                this.excelLoadTime = 0
                new swal({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Issue with Reports',
                    html: error.message,
                    timer: 10000,
                    icon: "error",
                    confirmButtonColor: "#10b45a",
                })
            })

            await new Promise(r => setTimeout(r, 2000));
            if (this.excelLoadTime != 0) {
                this.showLoadingSweetAlert('Your Excel document is loading.<br><br>This message will disappear automatically in 10 seconds.')
            }

            while (this.excelLoadTime != 0 && !this.error) {
                await new Promise(r => setTimeout(r, 10000));
                if (this.excelLoadTime != 0) {
                    this.showLoadingSweetAlert('Please hang tight.  Your Excel document is <i>still loading</i>.<br><br><b>Note: <br>Depending on how many orders you export, it could take anywhere from a few seconds to over 5 minutes.')
                }
            }
        }
    },
};
</script>

<style scoped>
.swal2-icon.swal2-info {
    font-size: 1rem !important;
}
</style>
